export default __webpack_public_path__ + "static/media/PL001.3.c66d702a.mp3";